module.exports = __webpack_public_path__ + "static/media/analogicos-02.ce6f862d.png";